import { ViewDetailIcon } from "@/constant/imagePath";
import IconButton from "..";

const ViewButton = ({
  icon = ViewDetailIcon,
  borderColor = "#C09600",
  fromColor = "#EDE517",
  toColor = "#C09600",
  buttonStyle = { padding: "1.5px" },
  onClick = null,
  tooltipText = "View Detail",
  ...props
}) => {
  return (
    <IconButton
      icon={icon}
      borderColor={borderColor}
      fromColor={fromColor}
      toColor={toColor}
      buttonStyle={buttonStyle}
      onClick={onClick}
      tooltipText={tooltipText}
      {...props}
    />
  );
};

export default ViewButton;
